import Mediator from "../../../utilities/Mediator"

export default class TriggerToStash {
  constructor(triggerToStash = {}) {
    this.triggersConfigMap = new Map()
    this.setTriggerMap(triggerToStash)
  }

  setTriggerMap(map) {
    if(map){
      Object.keys(map).forEach(key => {
        this.triggersConfigMap.set(key, map[key])
      })
    }
  }

  getTriggerMap() {
    let map = {}
    for (const key of this.triggersConfigMap.keys()) {
      let obj = {}
      obj[key] = this.triggersConfigMap.get(key)
      Object.assign(map, {...obj})
    }
    return map
  }

  setTriggerConfigList(processId, productId, equipmentId, triggers) {
    if(!processId && processId != 0) return;
    this.triggersConfigMap.set(`${processId}-${productId}-${equipmentId}`, triggers)
  }

  getTriggerConfigList(){
    let triggerConfigList = []
    for (const key of this.triggersConfigMap.keys()) {
      let split = key.split("-")
      triggerConfigList.push({
        name: this.setTriggerConfig(split[0], split[1], split[2]),
        key: key
      })
    }
    triggerConfigList.sort((a,b)=>a>b?1:b>a?-1:0)
    return triggerConfigList
  }

  setTriggerConfig(processId, productId, equipmentId){
    var getText = (array = new Array()) =>{
      return array.map(p => p.description)[0]
    }

    let processList = Mediator.data.productionProcess
    let productsList = Mediator.data.productionProducts
    let equipmentsList = Mediator.data.productionEquipments

    let process = getText(processList.filter(p => p.id == processId))
    let product = getText(productsList.filter(p => productId && p.id == productId))
    let equipment = getText(equipmentsList.filter(p => equipmentId && p.id == equipmentId))
    let result = `${process}`
    result += product ? ` / ${product}` : ""
    result += equipment ? ` / ${equipment}` : ""

    return result;
  }

  remove(triggerConfig){
    let key = this.getKeyByNameConfig(triggerConfig)
    this.triggersConfigMap.delete(key)
  }

  getTriggersSelected(trigger){
    let key = this.getKeyByNameConfig(trigger)
    return this.triggersConfigMap.get(key)
  }

  getKeyByNameConfig(triggerConfig){
    let keyFound = null
    for (const key of this.triggersConfigMap.keys()) {
      let split = key.split("-")
      let result = this.setTriggerConfig(split[0], split[1], split[2])
      if(result == triggerConfig){
        keyFound = key
        break;
      }
    }
    return keyFound;
  }
}
